import {
  HttpClient, HttpHeaders, HttpResponse as AngularHttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { apiConfiguration } from '../../../../configurations/api-configuration';
import { AccessService } from '../../../application/services/AccessService';
import { HttpResponse } from '../../../application/types/HttpResponse';
import {
  Order, PayOrderData, SaveOrderData, UpdateOrderData,
} from '../../types/Order';

@Injectable()
export class OrderApiService {
  private readonly ordersUrl = `${apiConfiguration.baseApiUrl}/orders`;

  public constructor(
    private http: HttpClient,
    private accessService: AccessService,
  ) { }

  public async getOrders(filters: { clientId?: string } = {}): Promise<HttpResponse<Order[]>> {
    const query = filters.clientId ? `?clientId=${encodeURIComponent(filters.clientId)}` : '';
    return lastValueFrom(this.http.get<HttpResponse<Order[]>>(`${this.ordersUrl}${query}`, { headers: this.getHeaders() }));
  }

  public async getOrder(orderId: string): Promise<HttpResponse<Order | null>> {
    return lastValueFrom(this.http.get<HttpResponse<Order | null>>(`${this.ordersUrl}/${encodeURIComponent(orderId)}`, { headers: this.getHeaders() }));
  }

  public async createOrder(data: SaveOrderData): Promise<HttpResponse<Order>> {
    return lastValueFrom(this.http.post<HttpResponse<Order>>(this.ordersUrl, data, { headers: this.getHeaders() }));
  }

  public async updateOrder(orderId: string, data: UpdateOrderData): Promise<HttpResponse<Order>> {
    return lastValueFrom(this.http.patch<HttpResponse<Order>>(`${this.ordersUrl}/${encodeURIComponent(orderId)}`, data, { headers: this.getHeaders() }));
  }

  public async payOrder(orderId: string, data: PayOrderData): Promise<HttpResponse<Order>> {
    return lastValueFrom(this.http.post<HttpResponse<Order>>(`${this.ordersUrl}/${orderId}/pay`, data, { headers: this.getHeaders() }));
  }

  public async cancelOrder(orderId: string): Promise<HttpResponse<Order>> {
    return lastValueFrom(this.http.post<HttpResponse<Order>>(`${this.ordersUrl}/${orderId}/cancel`, {}, { headers: this.getHeaders() }));
  }

  public async downloadTicketFile(orderId: string, ticketId: string): Promise<AngularHttpResponse<Blob>> {
    return lastValueFrom(this.http.get(`${this.ordersUrl}/${encodeURIComponent(orderId)}/tickets/${encodeURIComponent(ticketId)}/file`, {
      headers: this.getHeaders(),
      observe: 'response',
      responseType: 'blob',
    }));
  }

  private getHeaders(): HttpHeaders {
    const token = this.accessService.getToken();
    return token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : new HttpHeaders();
  }
}
